import { usableBatches } from 'src/sections/@dashboard/warehouse/utils/clinicalStock';
import { WarehouseBatchDto } from 'woofwoof-api';

export interface StockSummaryBatchRow {
  batch: WarehouseBatchDto;
  /** The Batch FEFO takes next (`usableBatches` order). */
  nextOut: boolean;
  expired: boolean;
}

/**
 * The Batches the details panel lists: those FEFO would take, in its order,
 * then the expired ones still holding stock. Empty Batches are left out.
 */
export function summaryBatchRows(
  batches: WarehouseBatchDto[],
  today: string,
): StockSummaryBatchRow[] {
  const usable = usableBatches(batches, today).map(
    (batch, index): StockSummaryBatchRow => ({
      batch,
      nextOut: index === 0,
      expired: false,
    }),
  );
  const expired = batches
    .filter((batch) => batch.onHandMilli > 0 && batch.expiryDate < today)
    .sort(
      (a, b) =>
        a.expiryDate.localeCompare(b.expiryDate) || a.id.localeCompare(b.id),
    )
    .map(
      (batch): StockSummaryBatchRow => ({
        batch,
        nextOut: false,
        expired: true,
      }),
    );
  return [...usable, ...expired];
}
